module.exports = __webpack_public_path__ + "images/emoji/heart.82e899ccbada01dffadb.png";